
import Api from "@/api/userService";
import ResultCodeType from "@/constant/ResultCodeType";
import AddUserParam from "@/model/AddUserParam";
import { message } from "ant-design-vue";
import { defineComponent, onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import routerName from "@/router/routerName";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "AddUser",
  setup() {
    const { t } = useI18n();
    const router = useRouter();
    const route = useRoute();
    const isEdit = route.query.isEdit as string;
    const user_id = route.query.id as string;
    const role_list = ref();
    const car_list = ref();
    const role_name = t("enduser");
    const formState = ref({
      id: "",
      username: "",
      mobile: "",
      role_id: "",
      confirm_password: "",
      password: "",
      vins: [] as any,
    });
    const agent_info = ref(
      JSON.parse(sessionStorage.getItem("agent_info") || "{}")
    );

    const clickItem = (val: any) => {
      if (formState.value.vins?.length > 0) {
        let have = true;
        formState.value.vins.forEach((vin: string) => {
          if (val == vin) {
            have = false;
          }
        });
        if (have) {
          formState.value.vins = [...formState.value.vins, val];
          message.warning(t("repeataddvinhint") + "(" + val + ")");
        }
      }
    };
    const checkParam = () => {
      if (formState.value.username == "") {
        message.error(t("inputusername"));
        return false;
      } else if (!isEdit && formState.value.password == "") {
        message.error(t("inputpassword"));
        return false;
      } else if (!isEdit && formState.value.confirm_password == "") {
        message.error(t("confirmpassword"));
        return false;
      } else if (
        !isEdit &&
        formState.value.confirm_password != formState.value.password
      ) {
        message.error(t("passwordinputsinconsistent"));
        return false;
      }

      return true;
    };
    const commit = () => {
      role_list.value.forEach((item: any) => {
        if (item.name === "终端用户") {
          formState.value.role_id = item.id;
        }
      });
      const params = {
        id: formState.value.id,
        username: formState.value.username,
        mobile: formState.value.mobile,
        role_id: formState.value.role_id,
        confirm_password: formState.value.confirm_password,
        password: formState.value.password,
        vins: JSON.parse(JSON.stringify(formState.value.vins)).join(","),
        agent_id: agent_info.value.agent_id,
      };
      if (isEdit) {
        editUserF(params);
      } else {
        addUserF(params);
      }
    };
    const editUserF = (params: AddUserParam) => {
      Api.editUser(params).then((val) => {
        console.log(val);
        if (val.err_no == 200) {
          message.success(t("edited"));
          goBack();
        } else {
          message.error(val.err_msg);
        }
      });
    };
    const addUserF = (params: AddUserParam) => {
      Api.addUser(params).then((val) => {
        console.log(val);
        if (val.err_no === ResultCodeType.success_200) {
          message.success(t("added"));
          goBack();
        } else {
          message.error(val.err_msg);
        }
      });
    };
    const submitForm = () => {
      if (checkParam()) {
        commit();
      }
    };
    const goBack = () => {
      router.go(-1);
    };
    const getuserdetailF = () => {
      const param = {
        id: user_id,
      };
      Api.getuserdetail(param).then((val) => {
        console.log(val);
        formState.value.username = val.result.username;
        formState.value.mobile = val.result.mobile;
        formState.value.role_id = val.result.role_id.toString();
        formState.value.vins = val.result.vins;
      });
    };
    const getRoleListF = () => {
      Api.getRoleList().then((val) => {
        if (val.err_no === ResultCodeType.success_200) {
          role_list.value = val.result;
        }
      });
    };
    const getUserCarsList = () => {
      const param = {
        category_name: "xdc",
      };
      Api.getUserCarsList(param).then((val) => {
        if (val.err_no === ResultCodeType.success_200) {
          car_list.value = val.result;
        }
      });
    };
    const labelCol = { style: { "min-width": "130px", "text-align": "left" } };
    onMounted(() => {
      getRoleListF();
      getUserCarsList();
      if (isEdit) {
        getuserdetailF();
        formState.value.id = user_id;
      }
    });
    return {
      formState,
      role_list,
      car_list,
      clickItem,
      submitForm,
      goBack,
      isEdit,
      role_name,
      labelCol,
      routerName,
      t,
    };
  },
});
